module.exports = __webpack_public_path__ + "static/media/baselineFileCopy.b12d06a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Icons/baselineFileCopy.svg
// module id = 163
// module chunks = 0